import { getTokenInfo } from "utils/getters";

export let dropdownItems = () => [
  {
    title: "bitcoin",
    imgSrc: getTokenInfo("BTC", "logoUrl64px"),
    symbol: "BTC",
  },
  {
    title: "binancecoin",
    imgSrc: getTokenInfo("BNB", "logoUrl64px"),
    symbol: "BNB",
  },
  {
    title: "cardano",
    imgSrc: getTokenInfo("ADA", "logoUrl64px"),
    symbol: "ADA",
  },
  {
    title: "ethereum",
    imgSrc: getTokenInfo("ETH", "logoUrl64px"),
    symbol: "ETH",
  },
  {
    title: "polkadot",
    imgSrc: getTokenInfo("DOT", "logoUrl64px"),
    symbol: "DOT",
  },
  {
    title: "shiba-inu",
    imgSrc: getTokenInfo("SHIB", "logoUrl64px"),
    symbol: "SHIB",
  },
  {
    title: "tether",
    imgSrc: getTokenInfo("USDT", "logoUrl64px"),
    symbol: "USDT",
  },
  {
    title: "dogecoin",
    imgSrc: getTokenInfo("DOGE", "logoUrl64px"),
    symbol: "DOGE",
  },
  {
    title: "litecoin",
    imgSrc: getTokenInfo("LTC", "logoUrl64px"),
    symbol: "LTC",
  },
  {
    title: "chainlink",
    imgSrc: getTokenInfo("LINK", "logoUrl64px"),
    symbol: "LINK",
  },
  {
    title: "tron",
    imgSrc: getTokenInfo("TRX", "logoUrl64px"),
    symbol: "TRX",
  },
  {
    title: "dai",
    imgSrc: getTokenInfo("DAI", "logoUrl64px"),
    symbol: "DAI",
  },
  {
    title: "uniSwap",
    imgSrc: getTokenInfo("UNI", "logoUrl64px"),
    symbol: "UNI",
  },
  {
    title: "wink",
    imgSrc: getTokenInfo("WIN", "logoUrl64px"),
    symbol: "WIN",
  },
  {
    title: "sushi",
    imgSrc: getTokenInfo("SUSHI", "logoUrl64px"),
    symbol: "SUSHI",
  },
  // {
  //   title: "PaxGold",
  //   imgSrc: getTokenInfo("PAXG", "logoUrl64px"),
  //   symbol: "PAXG",
  // },
  {
    title: "Filecoin",
    imgSrc: getTokenInfo("FIL", "logoUrl64px"),
    symbol: "FIL",
  },
  {
    title: "Ripple",
    imgSrc: getTokenInfo("XRP", "logoUrl64px"),
    symbol: "XRP",
  },
  {
    title: "harmony",
    imgSrc: getTokenInfo("ONE", "logoUrl64px"),
    symbol: "ONE",
  },
  {
    title: "tezos",
    imgSrc: getTokenInfo("XTZ", "logoUrl64px"),
    symbol: "XTZ",
  },
];
